{
	"RangeCombo_Search_Placeholder": "Search...",
	"RangeCombo_Search_More_Options_Message": "Search for more options",
	"Validation_Generic_Error_Message": "There are currently 1 or more errors detected",
	"Validation_Generic_Error_Max_Entries": "You have reached / gone over the maximum number of entries.",
	"NAME": "RangeComboLanguage"
}
